import { useParams } from "react-router-dom"
import useAxios from "../../../hooks/useAxios";
import { FaRegUser, FaProjectDiagram, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useEffect, useState } from "react";
import profileImg from '../../../images/profile.png';
import { Button, Dropdown, Modal, Table } from "react-bootstrap";
import { useFeedBack } from "../../../context/FeedBackContext";
import { monthNames, periodTypeDescription } from "../../../util/consts";
import RenderStatus from "../../../components/RenderStatus";
import ChangePayrrolStatusComponent from "../../../components/Payrrols/ChangePayrrolStatusComponent";
import PayrrolResponsibleComponent from "../../../components/PayrrolResponsible/PayrrolResponsibleComponent";
import update from 'immutability-helper';
import CostCenterNotificationEmailsComponent from "../../../components/CostCenters/CostCenterNotificationEmailsComponent";
import CostCenterItemDescriptionsComponent from "../../../components/CostCenters/CostCenterItemDescriptionsComponent";

const CostCentersUpdate = () => {

    const { id } = useParams();

    const [currentUsers, setCurrentUsers] = useState([]);

    const [currentResponsibles, setCurrentResponsibles] = useState([]);

    const [showAddResponsiblesModal, setShowAddResponsiblesModal] = useState(false);

    const [showCostCenterPositionItem, setShowCostCenterPositionItem] = useState(false);

    const [renderPositionItemsFilters, setRenderPositionItemsFilters] = useState({
        name: '',
        orderBy: 'name,ASC'
    });

    const [usersFilters, setUsersFilters] = useState({ search: '', page: 1 });

    const [{ data, loading }, getCostCenter] = useAxios({ url: `/cost-centers/${id}` }, { useCache: false });

    const [{ data: usersResponse, loading: loadingUsers }] = useAxios({ url: `/cost-centers/${id}/users/for-responsible`, params: usersFilters }, { useCache: false });

    const [{ }, getExcel] = useAxios({ url: `/cost-centers/${id}/excel-for-items-load`, responseType: 'blob' }, { manual: true, useCache: false });

    const [{ loading: payrrolResponsibleCreateLoading }, createPayrrolResponsible] = useAxios({ url: `/cost-centers/${id}/payrrol-responsible`, method: 'POST' }, { manual: true, useCache: false });

    const [{ data: renderPositionItemsData, loading: loadingRenderPositionItemsData }, getRenderPositionItemsData] = useAxios({ url: `/cost-centers/${id}/positions`, params: renderPositionItemsFilters }, { manual: true, useCache: false });

    useEffect(() => {
        if (showCostCenterPositionItem) getRenderPositionItemsData({ params: renderPositionItemsFilters })
    }, [showCostCenterPositionItem, renderPositionItemsFilters])

    useEffect(() => {
        if (data) {
            setCurrentResponsibles(data?.data?.payrrolResponsibles);
        };
    }, [data])

    useEffect(() => {
        if (usersResponse) {
            setCurrentUsers((oldUsers) => [...oldUsers, ...usersResponse?.data]);
        }
    }, [usersResponse]);

    const handleDeleteResponsible = (index) => {
        setCurrentResponsibles(update(currentResponsibles, { $splice: [[index, 1]] }));
    }

    const handleChangeUsersFilters = (e) => {
        setCurrentUsers([]);
        setUsersFilters((oldFilters) => {
            return {
                ...oldFilters,
                [e.target.name]: e.target.value,
                page: 1
            }
        });
    }

    const handleAddResponsible = (user) => {
        createPayrrolResponsible({
            data: {
                userId: user?.id
            }
        }).then((response) => {
            setCurrentResponsibles((oldResponsibles) => {
                return [...oldResponsibles, response?.data?.data];
            });
            setShowAddResponsiblesModal(false);
        });
    }

    const handleExcel = () => {
        getExcel().then(response => {
            const excelBlobUrl = URL.createObjectURL(response?.data);
            const aToDownload = document.getElementById('downloadLink');
            aToDownload.href = excelBlobUrl;
            aToDownload?.click();
            window.URL.revokeObjectURL(excelBlobUrl);
        })
    }

    const handleExcel2 = () => {
        getExcel({ url: `/cost-centers/${id}/excel-for-items-load-charges` }).then(response => {
            const excelBlobUrl = URL.createObjectURL(response?.data);
            const aToDownload = document.getElementById('downloadLink');
            aToDownload.href = excelBlobUrl;
            aToDownload?.click();
            window.URL.revokeObjectURL(excelBlobUrl);
        });
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <h2>{data?.data?.name}</h2>
                    <p className="mb-2">
                        <img src={data?.data?.boss?.imagePath || profileImg} style={{ marginRight: 10, height: 40, width: 40, borderRadius: '100%' }} alt="" />
                        <span className="text-primary">{data?.data?.boss?.name}</span>
                    </p>
                    <p className="mb-2">
                        <b>Cantidad de trabajadores: <span className="text-primary">{data?.data?.workersCount}</span> </b>
                    </p>
                    <p className="mb-2">
                        <b>Responsables: <span className="text-primary">{data?.data?.payrrolResponsiblesCount}</span> </b>
                    </p>
                </div>
                <div className="col-md-8 mb-3">
                    <div className="card">
                        <div className="card-header">
                            <h5>
                                Responsables:
                            </h5>
                        </div>
                        <div className="card-body">
                            <ul className="row align-items-center">
                                {currentResponsibles?.map((responsible, i) => {
                                    return (
                                        <PayrrolResponsibleComponent
                                            payrrolResponsible={responsible}
                                            onDelete={() => handleDeleteResponsible(i)}
                                            key={i}
                                        />

                                    )
                                })}
                                <li className="col-md-12 text-center my-5">
                                    <button className="btn btn-primary btn-block" onClick={() => setShowAddResponsiblesModal(true)}>
                                        Agregar
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <CostCenterNotificationEmailsComponent
                        costCenterId={id}
                    />
                </div>
                <div className="col-md-12 mb-3">
                    <CostCenterItemDescriptionsComponent
                        costCenterId={id}
                    />
                </div>
                <div className="col-md-12 mb-5">
                    <div className="card">
                        <div className="card-header">
                            <div className="row w-100 align-items-center justify-content-between">
                                <h5 className="col-5">
                                    <small style={{ fontSize: 10 }}>Configurar haberes</small>
                                    <br />
                                    Por cada cargo del centro de costo:
                                </h5>
                                <div className="col-3">
                                    <Dropdown>
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                            Descargar excel
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={handleExcel}>
                                                Cargos y Haberes
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleExcel2}>
                                                Solo Cargos
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className="col-3">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Buscar cargo..."
                                        value={renderPositionItemsFilters?.name}
                                        onChange={(e) => setRenderPositionItemsFilters((oldValues) => ({ ...oldValues, name: e.target.value }))}
                                    />
                                </div>
                                <div className="col-1 text-end">
                                    <button className="btn btn-xs btn-primary" onClick={() => setShowCostCenterPositionItem(oldValue => !oldValue)}>
                                        {
                                            showCostCenterPositionItem ?
                                                <FaChevronUp />
                                                :
                                                <FaChevronDown />
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            showCostCenterPositionItem &&
                            <div className="card-body custom-scrollbar scrollbar-primary" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                {
                                    loadingRenderPositionItemsData ?
                                        <div className="spinner">
                                            <div className="double-bounce1 bg-primary"></div>
                                            <div className="double-bounce2 bg-primary"></div>
                                        </div>
                                        :
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <th style={{ fontSize: 10 }} className="text-dark">
                                                        <strong>Nombre del Cargo</strong>
                                                    </th>
                                                    <th style={{ fontSize: 10 }} className="text-dark text-center">
                                                        <strong>Cantidad de trabajadores</strong>
                                                    </th>
                                                    <th style={{ fontSize: 10 }} className="text-dark text-end">
                                                        <strong>Acciones</strong>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    renderPositionItemsData?.map((position, i) => {
                                                        return (
                                                            <tr>
                                                                <td style={{ fontSize: 10 }} className="text-dark">
                                                                    <a href={`/centros-de-costos/${id}/cargo/${position?.id}/configurar-haberes`}>
                                                                        <strong>{position?.name}</strong>
                                                                    </a>
                                                                </td>
                                                                <td style={{ fontSize: 10 }} className="text-dark text-center">
                                                                    <strong>{position?.workersCount}</strong>
                                                                </td>
                                                                <td style={{ textAlign: 'end' }}>
                                                                    {/* <a href={`/centros-de-costos/${id}/cargo/${position?.id}/configurar-haberes`} className="btn btn-primary btn-xs">
                                                                        Configurar haberes
                                                                    </a> */}
                                                                    <a href={`/centros-de-costos/${id}/cargo/${position?.id}/configurar-haberes-2`} className="btn btn-primary btn-xs">
                                                                        Configurar haberes
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>

            <Modal animation="fade" show={showAddResponsiblesModal} onHide={() => setShowAddResponsiblesModal(false)} size="lg" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Seleccione el usuario que quiere asignar como responsable:
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="custom-scrollbar scrollbar-primary">
                    <input
                        type="text"
                        className="form-control"
                        value={usersFilters?.search}
                        onChange={handleChangeUsersFilters}
                        name="search"
                        placeholder="Buscar"
                    />
                    <br />
                    <ul>
                        {
                            currentUsers?.map((user, i) => {
                                return (

                                    <li key={i} className="mb-2 px-3" onClick={() => handleAddResponsible(user)} style={{ cursor: 'pointer' }}>
                                        <div className="d-flex align-items-center">
                                            <img src={user?.imagePath || profileImg} style={{ marginRight: 10, height: 40, width: 40, borderRadius: '100%' }} alt="" />
                                            <div>
                                                <p className="text-primary mb-0">{user?.name}</p>
                                                <p className="text-dark mb-0"><b>{user?.position?.name}</b></p>
                                                <p className="mb-0">{user?.documentNumber}</p>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                        }
                        {
                            !loadingUsers && usersResponse?.meta?.last_page > usersFilters?.page ?
                                <li className="text-center">
                                    <button className="btn btn-primary btn-xs" onClick={() => setUsersFilters(oldFilters => {
                                        return {
                                            ...oldFilters,
                                            page: oldFilters?.page + 1
                                        }
                                    })}>
                                        Cargar más
                                    </button>
                                </li>
                                :
                                null
                        }
                        {
                            currentUsers?.length === 0 && !loadingUsers ?
                                <li className="text-center my-5">
                                    No se encontrarón resultados.
                                </li>
                                :
                                null
                        }
                        {
                            loadingUsers &&
                            <li className="text-center my-5">
                                Cargando...
                            </li>
                        }
                    </ul>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default CostCentersUpdate;